import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import { logout as logoutAction } from 'services/store/auth/actions';
import useWavesurferContext from '../wavesurfer';
import useFacebookLogout from './useFacebookLogout';
import useGoogleLogout from './useGoogleLogout';

const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { logoutFromGoogle } = useGoogleLogout();
  const { logoutFromFacebook } = useFacebookLogout();
  const { changeSong } = useWavesurferContext();

  const logout = useCallback(() => {
    logoutFromFacebook();
    logoutFromGoogle();
    dispatch(logoutAction());
    navigate(locations.general.discovery.pathname);
    changeSong(null);
  }, [logoutFromFacebook, logoutFromGoogle, dispatch, navigate, changeSong]);

  return logout;
};

export default useLogout;
